import React from 'react';
import { Drawer, Badge, Button } from '@/components/ui';
import type { MaintenancePlan } from '../types/maintenance-plan.types';

export interface PlanDetailDrawerProps {
  plan: MaintenancePlan | null;
  isOpen: boolean;
  onClose: () => void;
}

export function PlanDetailDrawer({ plan, isOpen, onClose }: PlanDetailDrawerProps) {
  if (!plan) return null;

  return (
    <Drawer
      isOpen={isOpen}
      onClose={onClose}
      title={`Kế hoạch: ${plan.code}`}
      size="md"
    >
      <div className="p-6 space-y-6">
        <div className="flex items-center gap-4">
          <Badge variant={plan.status === 'active' ? 'success' : 'neutral'}>
            {plan.status === 'active' ? 'Đang hiệu lực' : plan.status}
          </Badge>
          <span className="text-sm font-semibold text-os-text">{plan.name}</span>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <div className="text-xs text-os-muted ">Khu vực</div>
            <div className="font-semibold text-os-text">{plan.zone_name}</div>
          </div>
          <div>
            <div className="text-xs text-os-muted ">Tần suất</div>
            <div className="font-semibold text-os-text">{plan.frequency}</div>
          </div>
          <div>
            <div className="text-xs text-os-muted ">Ngày bắt đầu</div>
            <div className="font-semibold text-os-text">{new Date(plan.start_date).toLocaleDateString('vi-VN')}</div>
          </div>
          <div>
            <div className="text-xs text-os-muted ">Ngày kết thúc</div>
            <div className="font-semibold text-os-text">{new Date(plan.end_date).toLocaleDateString('vi-VN')}</div>
          </div>
        </div>

        <div className="border-t border-slate-100 pt-4">
          <div className="text-xs text-os-muted  mb-4">Nguồn lực yêu cầu</div>
          <div className="bg-slate-50 p-4 rounded-lg border border-slate-100 grid grid-cols-2 gap-4 text-center">
            <div>
              <div className="text-2xl font-bold text-brand-600">{plan.standard_personnel}</div>
              <div className="text-xs text-os-muted mt-1">Nhân sự chuẩn</div>
            </div>
            <div>
              <div className="text-2xl font-bold text-brand-600">{plan.estimated_hours}</div>
              <div className="text-xs text-os-muted mt-1">Tổng giờ dự kiến</div>
            </div>
          </div>
        </div>

        <div className="bg-slate-50 p-4 rounded-lg border border-slate-100">
          <div className="text-xs text-os-muted  mb-2">Tiến độ tạo lịch</div>
          <div className="flex items-center gap-4">
            <div className="flex-1 h-2 bg-slate-200 rounded-full overflow-hidden">
              <div
                className="h-full bg-brand-500"
                style={{ width: `${(plan.schedules_created / (plan.schedules_total || 1)) * 100}%` }}
              />
            </div>
            <span className="text-sm font-medium">{plan.schedules_created}/{plan.schedules_total} lịch</span>
          </div>
          <div className="mt-4 flex justify-end">
            <Button variant="outline" size="sm">Xem trước lịch</Button>
          </div>
        </div>
      </div>
    </Drawer>
  );
}
